/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TradeOnboardingCoachmarkConditionalLoader_user = {
    readonly serviceId: string | null;
    readonly " $refType": "TradeOnboardingCoachmarkConditionalLoader_user";
};
export type TradeOnboardingCoachmarkConditionalLoader_user$data = TradeOnboardingCoachmarkConditionalLoader_user;
export type TradeOnboardingCoachmarkConditionalLoader_user$key = {
    readonly " $data"?: TradeOnboardingCoachmarkConditionalLoader_user$data;
    readonly " $fragmentRefs": FragmentRefs<"TradeOnboardingCoachmarkConditionalLoader_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "TradeOnboardingCoachmarkConditionalLoader_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'f94bcabbf168345679c1f91512d4e4ae';
export default node;
